const labels = {
  All: { 'See the offering': 'Podívejte se na nabídku' },
  FacilityDetails: { 'Ref: Page title': 'Detaily zařízení', 'Ref: Review': 'Posouzení' },
  FacilitiesList: {
    'Ref: Page title': 'Detaily zařízení',
    'Ref: See details': 'Zobrazit podrobnosti',
  },
};
export default labels;
